angular.module("avant.customer_applications.directives").directive "setFormAutocomplete", [
  "$timeout",
  ($timeout) ->
    restrict: "A"
    link: ($scope, element, attributes) ->
      # TODO: better solution for Chrome
      $timeout ->
        angular.forEach element.find('input,select'), (el) ->
          $(el).prop('autocomplete', attributes.setFormAutocomplete)
      , 1000
]